import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { StrapiSequence } from 'containers/Sequences/New/ModelePicker/types';

export const SEQUENCE_TEMPLATES_KEY = 'sequenceModeles';

function get() {
  const requestURL = '/cms/sequences';
  return request(requestURL, {
    method: 'GET',
  }).then<StrapiSequence[]>(({ data }) => data);
}

export function useSequenceModeles() {
  return useQuery({
    queryKey: [SEQUENCE_TEMPLATES_KEY],
    queryFn: () => get(),
    placeholderData: undefined,
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
